import type { ReactNode } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useAtomValue } from "jotai"
import { userAtom } from "../../state/auth"

interface ProtectedRouteProps {
  children?: ReactNode
  requiredRole?: string | string[]
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const user = useAtomValue(userAtom)
  const location = useLocation()

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  if (requiredRole) {
    const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole]
    const hasRole = roles.includes(user.role || "guest")

    if (!hasRole) {
      return <Navigate to="/" replace />
    }
  }

  if (children) return <>{children}</>
  return <Outlet />
}
